export const MultiLangDomains = {
  ch: [
    {
      lang: "de",
      formatId: "sidebar.lang.de",
      formatDefaultMsg: "German",
    },
    {
      lang: "fr",
      formatId: "sidebar.lang.fr",
      formatDefaultMsg: "French",
    },
    {
      lang: "it",
      formatId: "sidebar.lang.it",
      formatDefaultMsg: "Italian",
    },
    {
      lang: "en",
      formatId: "sidebar.lang.en",
      formatDefaultMsg: "English",
    },
  ],
  sa: [
    {
      lang: "ar",
      formatId: "sidebar.lang.ar",
      formatDefaultMsg: "Arabic",
    },
    {
      lang: "en",
      formatId: "sidebar.lang.en",
      formatDefaultMsg: "English",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/constants/multiLangSupport.js